// extracted by mini-css-extract-plugin
module.exports = {"filter":"ClasesCliente_filter__2jYp4"};